import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 36 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const ClipReveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ clipPath: "inset(100% 0 0 0)" }}
    whileInView={{ clipPath: "inset(0% 0 0 0)" }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 1, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ number, title, light = false }) => (
  <Reveal>
    <p
      data-testid={`chapter-${number}`}
      className={`text-xs uppercase tracking-[0.35em] font-medium ${light ? "text-cream/60" : "text-charcoal/50"}`}
    >
      {title}
    </p>
  </Reveal>
);

export { EASE };
